import { Box, Button, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import * as Time from "@outschool/time";
import { ConfirmationModal } from "@outschool/ui-legacy-component-library";
import React from "react";

import UserAvatar from "../common/UserAvatar";
import { Sender } from "../types";

export interface ClassPostCommentSenderPhotoAndPublishDateProps {
  commentUid: string;
  postUid: string;
  canManage?: boolean;
  sender: Sender;
  publishedAt: Date;
  onUserClick?: (user: Sender) => void;
  userHref?: string;
  timeZone?: string;
  handleDeleteAssignmentComment?: (
    commentUid: string,
    postUid: string
  ) => Promise<void>;
}

const ClassPostCommentSenderPhotoAndPublishDate = ({
  commentUid,
  postUid,
  canManage,
  sender,
  publishedAt,
  timeZone,
  onUserClick,
  userHref,
  handleDeleteAssignmentComment,
}: ClassPostCommentSenderPhotoAndPublishDateProps) => {
  const { t } = useTranslation(
    "ui-components-classroom\\classroom\\ClassPostComment\\ClassPostCommentSenderPhotoAndPublishDate"
  );
  const [commentToDelete, setCommentToDelete] = React.useState<string | null>(
    null
  );
  const handleDeleteCommentConfirm = React.useCallback((commentUid: string) => {
    setCommentToDelete(commentUid);
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
      }}
    >
      <UserAvatar
        size={30}
        sender={sender}
        onClick={onUserClick}
        href={userHref}
      />
      <Typography
        variant="body1"
        sx={{
          fontWeight: "700",
        }}
      >
        {sender.name?.trim()}
      </Typography>
      <Typography variant="body2" sx={{ color: "neutral.500" }}>
        {Time.formatDateTimeWithFullWeekday(publishedAt, timeZone)}
      </Typography>
      {canManage && (
        <>
          <Button
            variant="link"
            onClick={() => handleDeleteCommentConfirm(commentUid)}
            sx={{ color: "error.500" }}
          >
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <>{"X"}</>
          </Button>

          <ConfirmationModal
            buttonColor="danger"
            open={!!commentToDelete}
            confirmationLabel={t("Delete comment")}
            onConfirm={async () => {
              if (!!handleDeleteAssignmentComment) {
                await handleDeleteAssignmentComment(commentUid, postUid);
              }
            }}
            onClose={() => setCommentToDelete(null)}
            hasCloseButton={false}
          />
        </>
      )}
    </Box>
  );
};

export default ClassPostCommentSenderPhotoAndPublishDate;
